/**
 * 我们的优势
 */
import * as React from 'react'
import Card from './Card'
import Description from './Description'
import styles from './index.module.less'

export default function Index({ translateTxt, onRouteChange }: any) {
  return (
    <div className={styles.advantage}>
      <div className={styles.title}>{translateTxt('dashboard:t5')}</div>
      <div className={styles.section}>
        <div className={styles.row}>
          <Card style={{ marginRight: 140 }} url={translateTxt('dashboard:image.t2')} />
          <Description
            title={translateTxt('dashboard:t6')}
            sortNum={0}
            contents={[translateTxt('dashboard:t7'), translateTxt('dashboard:t8')]}
            translateTxt={translateTxt}
            handleClick={() => onRouteChange('/inspiration/template')}
          />
        </div>
        <div className={styles.row} style={{ justifyContent: 'space-between' }}>
          <Description
            sortNum={1}
            title={translateTxt('dashboard:t9')}
            contents={[
              translateTxt('dashboard:t10'),
              translateTxt('dashboard:t11'),
              translateTxt('dashboard:t12'),
              translateTxt('dashboard:t13'),
            ]}
            translateTxt={translateTxt}
            handleClick={() => onRouteChange('/inspiration/template')}
          />
          <Card url={translateTxt('dashboard:image.t3')} />
        </div>
        <div className={styles.row}>
          <Card style={{ marginRight: 140 }} url={translateTxt('dashboard:image.t4')} />
          <Description
            sortNum={2}
            title={translateTxt('dashboard:t14')}
            contents={[
              translateTxt('dashboard:t16'),
              translateTxt('dashboard:t17'),
              translateTxt('dashboard:t18'),
              translateTxt('dashboard:t19'),
            ]}
            translateTxt={translateTxt}
            handleClick={() => onRouteChange('/data/diagnosis')}
          />
        </div>
      </div>
    </div>
  )
}
